import React, { useEffect, useState } from "react";

import LegendComponent from "../components/LegendComponent";
import AlimtalkMapContainer from "./AlimtalkMapContainer";
import { targetCrops } from "../data/fireblightOptionData";

const getYearOptions = (minDate, todayDate) => {
  if (minDate && todayDate) {
    let yearOptions = [];
    const minDateYear = new Date(minDate).getFullYear();
    let currentYear = new Date(todayDate).getFullYear();
    while (minDateYear <= currentYear) {
      yearOptions.push(currentYear);
      currentYear -= 1;
    }
    return yearOptions;
  }
};

const AlimtalkRightSideComponent = (props) => {
  const {
    setLoading,
    setError,
    minDate,
    today,
    totalSpots,
    setTotalSpots,
    targetCrop,
    setTargetCrop,
    targetYear,
    setTargetYear,
    sigunguList = [],
    targetRegion,
    setTargetRegion,
    selectSpot,
    nowDateTime,
    getFBSpots,
  } = props;

  const [yearOptions, setYearOptions] = useState([]);

  const alimtalkLegend = [
    { id: 1, value: 0, titleKo: "발송 없음", color: "#dcdcdc" },
    { id: 2, value: 1, titleKo: "계획발송차수=실제발송차수 (일치)", color: "#006eff" },
    { id: 3, value: 2, titleKo: "계획발송차수≠실제발송차수 (불일치)", color: "#ff8686" },
  ];

  const onChangeTargetCrop = (e) => {
    const cropId = e.target.value;
    const target = targetCrops.filter((item) => item.id == cropId)[0];
    if (target) setTargetCrop(target);
  };

  const onChangeYearOption = (e) => {
    setTargetYear(e.target.value);
  };

  const onChangeRegion = (e) => {
    const region = e.target.value;
    const target = sigunguList.filter((item) => item.region === region)[0];
    if (target) setTargetRegion(target);
  };


  useEffect(() => {
    setYearOptions(getYearOptions(minDate, today));
    if (targetYear && targetCrop) {
      getFBSpots(
        (data) => setTotalSpots(data),
        (data) => setLoading(data),
        (data) => setError(data),
        targetCrop,
        targetYear,
        targetRegion
      );
    }
  }, [targetYear, targetCrop, targetRegion, nowDateTime]);

  return (
    <div className="container right">
      <div className="select-area position-1">
        <div className="form-inline box">
          <h3>조회 조건</h3>
          <div className="form-group">
            <select className="form" onChange={onChangeYearOption} value={targetYear}>
              {yearOptions.map((year) => (
                <option key={`yearOption-${year}`} value={year}>
                  {year}년
                </option>
              ))}
            </select>
            <select className="form" onChange={onChangeTargetCrop} value={targetCrop ? targetCrop.id : ""}>
              {targetCrops.map((crop) => (
                <option key={`cropOption-${crop.id}`} value={crop.id}>
                  {crop.titleKo}
                </option>
              ))}
            </select>
            <select className="form" onChange={onChangeRegion} value={targetRegion ? targetRegion.region : "all"}>
              {sigunguList.map((sigungu) => (
                <option key={`regionOption-${sigungu.region}`} value={sigungu.region}>
                  {sigungu.regionDesc}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="legend-area box">
        <LegendComponent data={alimtalkLegend} />
      </div>
      <div className="map">
        <AlimtalkMapContainer
          totalSpots={totalSpots}
          selectSpot={selectSpot}
        />
      </div>
    </div>
  );
};

export default AlimtalkRightSideComponent;
